if (!customElements.get('rome-scroll-fade')) {
 customElements.define('rome-scroll-fade', class extends HTMLElement {
  connectedCallback() {
   this.slides=Array.from(this.querySelectorAll('.rs-fade__slide'));
   if(this.slides.length<2)return;
   this.stage=this.querySelector('.rs-fade__stage');
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');
   this.abort=new AbortController();
   this.setAttribute('data-enhanced','');
   this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.render()})};
   this.measure=()=>{
    const points=this.slides[this.slides.length-1].querySelectorAll('h5');
    if(points.length>=3){
     const a=points[points.length-3],b=points[points.length-2];
     this.style.setProperty('--rs-guarantee-gap',Math.max(0,b.offsetTop-a.offsetTop-a.offsetHeight)+'px');
    }
    const height=this.stage.getBoundingClientRect().height;
    const compactTravel=parseFloat(getComputedStyle(this).getPropertyValue('--rs-scroll-travel'));
    this.travel=(compactTravel>0?compactTravel:innerHeight*1.3)*(this.slides.length-1);
    this.flow=parseFloat(getComputedStyle(this).getPropertyValue('--rs-scroll-flow'))===1;
    this.style.height=this.flow?'auto':(height+this.travel)+'px';
    this.stage.style.top=(this.flow?0:(parseFloat(getComputedStyle(this).getPropertyValue('--rs-sticky-offset'))||0))+'px';
    this.fadeStart=this.flow?Math.max(parseFloat(getComputedStyle(this).getPropertyValue('--header-height'))||0,(innerHeight-height)/2):parseFloat(this.stage.style.top||0);
    this.queue();
   };
   addEventListener('scroll',this.queue,{passive:true,signal:this.abort.signal});
   addEventListener('resize',this.measure,{signal:this.abort.signal});
   this.addEventListener('shopify:block:select',e=>{
    const slide=e.target.closest('.rs-fade__slide');
    const i=this.slides.indexOf(slide);
    if(i<0)return;
    const start=scrollY+this.getBoundingClientRect().top-this.fadeStart;
    scrollTo({top:start+this.travel*i/(this.slides.length-1),behavior:'instant'});
    this.queue();
   },{signal:this.abort.signal});
   this.observer=new ResizeObserver(this.measure);this.observer.observe(this.stage);
   this.measure();this.render();
  }
  render(){
   const clamp=x=>Math.max(0,Math.min(1,x));
   const ease=x=>{x=clamp(x);return x*x*(3-2*x)};
   const progress=clamp((this.fadeStart-this.getBoundingClientRect().top)/Math.max(1,this.travel))*(this.slides.length-1);
   this.slides.forEach((slide,i)=>{
    let opacity;
    if(this.motion.matches)opacity=Math.round(progress)===i?1:0;
    else if(progress>=i)opacity=1-ease((progress-i-.30)/.40);
    else opacity=ease((progress-i+1-.30)/.40);
    slide.style.opacity=opacity;
    slide.style.visibility=opacity>0?'visible':'hidden';
    slide.inert=opacity<.5;
    slide.setAttribute('aria-hidden',String(opacity<.5));
   });
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame)}
 });
}
